import React from 'react';

interface AccordianHeaderProps {
    item: {
        readableshellacronym?: string;
        shelltitle?: string;
    };
}

const AccordianHeader: React.FC<AccordianHeaderProps> = ({ item }) => {
    return (
        <div className="flex flex-row items-center">
            <p className="font-bold text-black">
                {item?.shelltitle || 'No Title'}
            </p>
        </div>
    );
};

export default AccordianHeader;
